export default __webpack_public_path__ + "static/media/CruiseQueenImgTwo.144d004a.png";